import { render, staticRenderFns } from "./GerenciarCalendario.vue?vue&type=template&id=0701ad7a"
import script from "./GerenciarCalendario.vue?vue&type=script&lang=js"
export * from "./GerenciarCalendario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports